var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "产品授权",
            visible: _vm.dialogFormVisible,
            width: "80%",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: { model: _vm.form, inline: "", "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品分类：" } },
                [
                  _c("el-cascader", {
                    staticClass: "selWidth",
                    attrs: {
                      options: _vm.merCateList,
                      props: _vm.props,
                      clearable: "",
                      size: "small",
                      placeholder: "请选择",
                    },
                    on: { change: _vm.getList },
                    model: {
                      value: _vm.form.cateId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cateId", $$v)
                      },
                      expression: "form.cateId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称：" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.form.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "productName", $$v)
                      },
                      expression: "form.productName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "SKU编码：" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.form.skuCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "skuCode", $$v)
                      },
                      expression: "form.skuCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品品牌：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth",
                      attrs: {
                        placeholder: "请选择",
                        filterable: "",
                        clearable: "",
                        remote: "",
                        "remote-method": _vm.brandRemoteMethod,
                        size: "small",
                      },
                      on: { change: _vm.getList },
                      model: {
                        value: _vm.form.brandId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "brandId", $$v)
                        },
                        expression: "form.brandId",
                      },
                    },
                    _vm._l(_vm.brandList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.brandName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品供应商：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth",
                      attrs: {
                        placeholder: "请选择",
                        filterable: "",
                        clearable: "",
                        remote: "",
                        "remote-method": _vm.remoteMethod,
                        size: "small",
                      },
                      on: { change: _vm.getList },
                      model: {
                        value: _vm.form.supplierId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "supplierId", $$v)
                        },
                        expression: "form.supplierId",
                      },
                    },
                    _vm._l(_vm.suppliers, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.supplierName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "filter-buttons" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "ios-search",
                        label: "default",
                        size: "small",
                      },
                      on: { click: _vm.getList },
                    },
                    [
                      _c("i", { staticClass: "el-icon-search el-icon--left" }),
                      _vm._v("\n          搜索\n        "),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "折扣设置：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.form.unify,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "unify", $$v)
                          },
                          expression: "form.unify",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.unifyUpdate },
                        },
                        [_vm._v("统一改价")]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "供货价=成本价*输入值。如需统一加价15%，则输入1.15"
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.pageLists[
                      _vm.listPram.page - 1 >= 0 ? _vm.listPram.page - 1 : 0
                    ],
                    "row-key": "skuId",
                    "max-height": "500",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "skuId", label: "SKU ID", width: "80" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "skuCode", label: "SKU编码", width: "100" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "skuName", label: "名称" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "brandName", label: "品牌" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "supplierName", label: "供应商" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "retailPrice",
                      label: "零售价",
                      width: "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "costPrice", label: "成本价", width: "100" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "supplyPrice",
                      label: "供货价",
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              staticStyle: { width: "100px" },
                              attrs: { controls: false },
                              model: {
                                value: scope.row.supplyPrice,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "supplyPrice", $$v)
                                },
                                expression: "scope.row.supplyPrice",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "distributionPrice",
                      label: "售价",
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              staticStyle: { width: "100px" },
                              attrs: { controls: false },
                              model: {
                                value: scope.row.distributionPrice,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "distributionPrice", $$v)
                                },
                                expression: "scope.row.distributionPrice",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.listPram.page,
                  "page-sizes": _vm.constants.page.limit,
                  layout: _vm.constants.page.layout,
                  total: _vm.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("确认添加")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }